import { useEffect, useState } from 'react';
import { useScroll, useThrottle, useWindowSize } from 'react-use';

function useNavButtonsDisabled(listRef) {
  const [prevButtonDisabled, setPrevButtonDisabled] = useState(false);
  const [nextButtonDisabled, setNextButtonDisabled] = useState(false);
  const scrollState = useScroll(listRef);
  const throttledScrollState = useThrottle(scrollState, 400);
  const windowSize = useWindowSize();

  useEffect(() => {
    const listElement = listRef.current;

    if (!listElement) {
      return;
    }

    if (listElement.scrollLeft === 0) {
      setPrevButtonDisabled(() => true);
    } else {
      setPrevButtonDisabled(() => false);
    }

    if (
      listElement.offsetWidth + listElement.scrollLeft >=
      listElement.scrollWidth
    ) {
      setNextButtonDisabled(() => true);
    } else {
      setNextButtonDisabled(() => false);
    }
  }, [listRef, throttledScrollState.x, windowSize.width, windowSize.height]);

  return { prevButtonDisabled, nextButtonDisabled };
}

export default useNavButtonsDisabled;
